import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbstractUiEntityStore } from '../../data/abstract-ui-entity.store';
import { TimeCard } from './time-card';
import { Project } from '../../project-misc/data/project/project';

export interface TimeCardsState extends EntityState<TimeCard, number> {
    ui: {
        todayCards: TimeCard[],
        todayTotalTime: number,
        weekTotalTime: number,
        ppTotalTime: number,
        breakTime: number,
        firstTimeCard: TimeCard
        lastTimeCard: TimeCard,
        punchedIn: boolean,
        chosenProject: Project
    };
}

@Injectable({
    providedIn: 'root'
})
@StoreConfig({ name: 'timeCards' })
export class TimeCardsStore extends AbstractUiEntityStore<TimeCardsState> {
    constructor() {
        super({
            ui: {
                todayCards: [],
                todayTotalTime: 0,
                weekTotalTime: 0,
                ppTotalTime: 0,
                breakTime: 0,
                firstTimeCard: null,
                lastTimeCard: null,
                punchedIn: false,
                chosenProject: null
            }
        })
    }

    updateChoosenProject(chosenProject: Project) {
        this.updateUi({
            ...this._value(),
            chosenProject
        })
    }

    updateTodayTimeCards(todayCards: TimeCard[]) {
        this.updateUi({
            ...this._value(),
            todayCards
        })
    }

    updateFirstTimeCard(firstTimeCard: TimeCard) {
        this.updateUi({
            ...this._value(),
            firstTimeCard
        })
    }

    updateLastTimeCard(lastTimeCard: TimeCard) {
        this.updateUi({
            ...this._value(),
            lastTimeCard
        })
    }

    updateTodayTime(todayTotalTime: number) {
        this.updateUi({
            ...this._value(),
            todayTotalTime
        })
    }

    updateWeekTime(weekTotalTime: number) {
        this.updateUi({
            ...this._value(),
            weekTotalTime
        })
    }

    updatePPTime(ppTotalTime: number) {
        this.updateUi({
            ...this._value(),
            ppTotalTime
        })
    }

    updateBreakTime(breakTime: number) {
        this.updateUi({
            ...this._value(),
            breakTime
        })

    }

    unshiftTimeCard(timeCard: TimeCard) {
        this.updateFirstTimeCard(timeCard)
        this.updateTodayTimeCards([timeCard, ...this._value().ui.todayCards]);
    }

    updatePunchStatus(punchedIn: boolean) {
        this.update({
            ...this._value(),
            punchedIn
        })
    }

}